import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';

import { InfoContainer, InfoPhotoContainer, InfoTypeWrapper, InfoWrapper, InfoType, InfoHeading, InfoStars, InfoVotes, InfoAddress } from './styles';

const BookingHotelInfo = ({ photos, productName, hotelName, rating, totalReviews, address, }) => (
  <InfoContainer>
    {photos && (
      <InfoPhotoContainer length={photos.length}>
        {photos.map(photo => <img key={photo} src={`${process.env.CDN_URL}${photo}`} alt={hotelName} />)}
      </InfoPhotoContainer>
    )}
    <InfoWrapper>
      <InfoTypeWrapper>
        <InfoType>{productName}</InfoType>
      </InfoTypeWrapper>
      <InfoHeading>{hotelName}</InfoHeading>
      <InfoStars>
        <StarRatings
          rating={rating === 0 ? 5 : rating}
          numberOfStars={5}
          starRatedColor="#1eb6ff"
          starEmptyColor="#b6e4f9"
          starDimension="15px"
          starSpacing="0px"
        />
        {totalReviews !== 0 && <InfoVotes>{totalReviews}</InfoVotes>}
      </InfoStars>
      <InfoAddress>
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" fill="none">
          <path fill="#1EB6FF" fillRule="evenodd" d="M8.86 4.6c0 2.77-4.43 8.3-4.43 8.3S0 7.37 0 4.6C0 2.07 1.98 0 4.43 0a4.52 4.52 0 0 1 4.43 4.6zm-3.54 0c0 .52-.4.93-.89.93a.9.9 0 0 1-.88-.92c0-.51.4-.92.88-.92a.9.9 0 0 1 .89.92z" clipRule="evenodd" />
        </svg>
        {address}
      </InfoAddress>
    </InfoWrapper>
  </InfoContainer>
);

BookingHotelInfo.propTypes = {
  photos: PropTypes.instanceOf(Array),
  productName: PropTypes.string,
  hotelName: PropTypes.string,
  rating: PropTypes.number,
  totalReviews: PropTypes.number,
  address: PropTypes.string,
};

export default BookingHotelInfo;
